/* eslint-disable @eslint-react/dom/no-dangerously-set-innerhtml */
import { getComponentFromName } from '@folklore/utils';
import { ForwardedRef, HTMLAttributes, ReactNode, Suspense } from 'react';

import useFormatImageUrl from '../../hooks/useFormatImageUrl';
import { getImageUrl } from '../../lib/getImageSize';

import * as ThemeComponents from './index';

interface PageThemeProps extends HTMLAttributes<HTMLDivElement> {
    id: string;
    containerClassName: string;
    name?: string | null;
    primaryColor?: string | null;
    textColor?: string | null;
    backgroundColor?: string | null;
    backgroundImage?: Image | null;
    children: ReactNode;
}

function PageTheme({
    id,
    containerClassName,
    name = null,
    primaryColor = null,
    backgroundColor = null,
    textColor = null,
    backgroundImage = null,
    children,
    ref = null,
    ...props
}: PageThemeProps & { ref?: ForwardedRef<HTMLDivElement> | null }) {
    const formatImageUrl = useFormatImageUrl();
    const backgroundImageUrl = formatImageUrl(getImageUrl(backgroundImage, 'large'));
    const ThemeWrapper = getComponentFromName(ThemeComponents, name, null);

    return (
        <>
            <style
                type="text/css"
                dangerouslySetInnerHTML={{
                    __html: `
                #${id}.${containerClassName} {
                    ${primaryColor !== null ? `--page-primary-color: ${primaryColor};` : ''}
                    ${textColor !== null ? `--page-text-color: ${textColor};` : ''}
                    ${backgroundColor !== null && backgroundImageUrl !== null ? `--page-background: ${backgroundColor} url("${backgroundImageUrl}") top center repeat;` : ''}
                    ${backgroundColor !== null && backgroundImageUrl === null ? `--page-background: ${backgroundColor};` : ''}
                    ${backgroundImageUrl !== null && backgroundColor === null ? `--page-background: url("${backgroundImageUrl}") top center repeat;` : ''}
                }
            `,
                }}
            />
            {ThemeWrapper !== null ? (
                <Suspense
                    fallback={
                        <div id={id} {...props} ref={ref}>
                            {children}
                        </div>
                    }
                >
                    <ThemeWrapper id={id} {...props} ref={ref}>
                        {children}
                    </ThemeWrapper>
                </Suspense>
            ) : (
                <div id={id} {...props} ref={ref}>
                    {children}
                </div>
            )}
        </>
    );
}

export default PageTheme;
